import actionTypes from "./../constants/actionTypes";
import { getForms, getList } from "./formActions";
import cronstrue from 'cronstrue';
import { formatValueWithType } from "../utils/utility";
import ExternalApiRequest from "./../utils/ExternalApiRequest";

export const listCronJobs = (requestPayload, listFormKey) => {
    try {
        return async (dispatch, getState) => {
            const { forms = {} } = getState();
            const { formJson = {} } = forms;
            const formData = formJson[listFormKey] || {}
            const listResponse = await getList(requestPayload, "listCronjobs", "jobs");
            const listJson = formListJson(formData, listResponse);
            return dispatch({
                type: actionTypes.ADMIN.CRONJOB_LIST,
                payload: listJson,
            });
        }
    } catch (error) {
        console.log(error);
    }
}

export const listAlertTrades = (requestPayload, listFormKey) => {
    try {
        return async (dispatch, getState) => {
            const { forms = {} } = getState();
            const { formJson = {} } = forms;
            const formData = formJson[listFormKey] || {}
            const listResponse = await getList(requestPayload, "monitorAlertTrades");
            const { payload = {}, meta = {} } = listResponse;
            const { list = [] } = payload;
            // const { monitorListObj = {}, ...restPayload } = payload;
            // const newList = Object.keys(monitorListObj).map(key => ({ ...restPayload, ...monitorListObj[key] }));
            const listJson = formListJson(formData, { meta, list }, "list");
            return dispatch({
                type: actionTypes.ADMIN.TRADE_ALERT_LIST,
                payload: listJson,
            });
        }
    } catch (error) {
        console.log(error);
    }
}

const formListJson = (formPayload, listPayload, listKey = 'jobs') => {
    const { data = {}, meta = {} } = formPayload;
    const list = listPayload[listKey];
    const { meta: listMeta = {} } = listPayload;
    const { section = [] } = data;
    const { users = {} } = listMeta;
    const [firstSection = {}] = section;
    const { fields = [] } = firstSection;
    const listData = list.map(data => {
        const { api = [], pattern = '', lastRunResult = {}, userId = '', avgBuyPrice = 0, ltp = 0, totalQty = 0, strategyId = '' } = data;
        const { action = 'N/A', reason = 'N/A' } = lastRunResult;
        const rowData = fields.reduce((accum, field, index) => {
            let value = '';
            switch (field.id) {
                case "userIdDisplay": {
                    const user = users[userId];
                    const { title = '', firstName = '', lastName = '' } = user || {};
                    value = user ? `${title}. ${firstName} ${lastName} (${userId})` : userId;
                    break;
                }
                case "avgBuyPriceValue": {
                    value = avgBuyPrice;
                    break
                }
                case "strategyIdLink": {
                    value = { value: strategyId, link: `/configurations/edit?id=${strategyId}` }
                    break;
                }
                case "api": {
                    value = api.map(apiData => apiData.type).join(', ');
                    break;
                }
                case "pattern": {
                    value = pattern ? cronstrue.toString(pattern) : 'N/A';
                    break;
                }
                case "lastRunAction": {
                    value = action;
                    break;
                }
                case "lastRunReason": {
                    value = reason;
                    break;
                }
                case "pnl": {
                    value = formatValueWithType((ltp - avgBuyPrice) * totalQty);
                    break;
                }
                case "pnlPercentageTradeTracking": {
                    value = formatValueWithType(((ltp - avgBuyPrice) / avgBuyPrice) * 100);
                    break;
                }
                default: value = data[field.id] || '';
            }
            return { ...accum, [field.id]: value };
        }, {});
        return rowData;
    });
    return { headers: fields, data: listData, meta };
}

export const adminActions = (requestPayload, listFormKey) => {
    try {
        return async (dispatch, getState) => {
            const { fetchLeverage = false, fetchStocksHistory = false, historyUpdate = false, fetchStocksList = false,
                fetchAdditionalInfo = 0, forceUpdate = false
            } = requestPayload;

            const exectionOrder = [
                {
                    apiKey: 'fetchStocksList',
                    value: fetchStocksList,
                    payload: {
                        "fetchAdditionalInfo": fetchAdditionalInfo
                    },
                },
                {
                    apiKey: 'fetchStocksHistory',
                    value: fetchStocksHistory || forceUpdate,
                    payload: {
                        forceUpdate
                    },
                },
                {
                    apiKey: 'historyUpdate',
                    value: historyUpdate,
                    payload: {},
                },
                {
                    apiKey: 'fetchLeverage',
                    value: fetchLeverage,
                    payload: {},
                }
            ]
            let responseArray = [];

            for (let index = 0; index < exectionOrder.length; index++) {
                const { apiKey = '', value = false, payload = {} } = exectionOrder[index];
                if (value) {
                    let options = {
                        api: apiKey,
                        content: payload
                    };
                    let response = await ExternalApiRequest(options);
                    const { payload: responsePayload = {} } = response;
                    responseArray.push(responsePayload);
                } else {
                    responseArray.push({});
                }
            }

            return dispatch({
                type: actionTypes.ADMIN.ACTIONS_COMPLETE,
                payload: responseArray,
            });
        }
    } catch (error) {
        console.log(error);
    }
}

export const getAccessControl = (payload) => {
    try {
        return async (dispatch, getState) => {
            const options = {
                api: 'getAccessControl',
                content: payload
            };
            const response = await ExternalApiRequest(options);
            const { payload: responsePayload = {} } = response;
            return dispatch({
                type: actionTypes.ADMIN.ACCESS_CONTROL_LIST,
                payload: responsePayload,
            });
        }
    } catch (error) {
        console.log(error);
    }
}

export const getHistoryDateSummary = () => {
    return async (dispatch) => {
        try {
            const response = await ExternalApiRequest({ api: 'historyDateSummary', content: {} });
            const { payload = {} } = response;
            return dispatch({ type: actionTypes.ADMIN.HISTORY_DATE_SUMMARY, payload });
        } catch (error) {
            console.log(error);
            return dispatch({ type: actionTypes.ADMIN.HISTORY_DATE_SUMMARY, payload: {} });
        }
    }
}

export const saveAccessControl = (payload) => {
    try {
        return async (dispatch, getState) => {
            const options = {
                api: 'saveAccessControl',
                content: payload
            };
            const response = await ExternalApiRequest(options);
            return dispatch({
                type: actionTypes.ADMIN.SAVE_ACCESS_CONTROL_LIST,
                payload: response,
            });
        }
    } catch (error) {
        console.log(error);
    }
}
